import initialState from "./initialState";

export function ContractPriceReducer(
  state = initialState.searchContractPriceParams,
  action
) {
  switch (action.type) {
    case "SEARCH_CONTRACT_PRICE_REQUEST":
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
}
